var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Field Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9749 12.9306L24.9669 12.9271L3.66354 4.09113C3.48436 4.01613 3.28938 3.98672 3.09605 4.00552C2.90271 4.02432 2.71705 4.09075 2.55568 4.19887C2.38518 4.31059 2.24513 4.46294 2.14814 4.64222C2.05114 4.82151 2.00023 5.02209 2 5.22593V10.877C2.0001 11.1557 2.0974 11.4256 2.27514 11.6402C2.45288 11.8548 2.69992 12.0007 2.97368 12.0527L14.5926 14.2011C14.6382 14.2097 14.6794 14.2341 14.7091 14.2698C14.7387 14.3056 14.7549 14.3507 14.7549 14.3971C14.7549 14.4436 14.7387 14.4886 14.7091 14.5244C14.6794 14.5602 14.6382 14.5845 14.5926 14.5932L2.97418 16.7415C2.7005 16.7934 2.45347 16.9391 2.27565 17.1535C2.09783 17.368 2.00035 17.6377 2 17.9163V23.5683C1.99987 23.763 2.04806 23.9546 2.14026 24.126C2.23246 24.2974 2.36577 24.4433 2.52824 24.5505C2.72368 24.6803 2.95304 24.7497 3.18768 24.75C3.3508 24.7499 3.51225 24.7171 3.66255 24.6537L24.9654 15.8681L24.9749 15.8636C25.2616 15.7404 25.506 15.5358 25.6776 15.2751C25.8493 15.0145 25.9408 14.7092 25.9408 14.3971C25.9408 14.085 25.8493 13.7797 25.6776 13.5191C25.506 13.2584 25.2616 13.0538 24.9749 12.9306Z",
    fill: "#4D3ECC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveArrow);
export default __webpack_public_path__ + "static/media/activeArrow.824975426e8d5c85860526ac58791251.svg";
export { ForwardRef as ReactComponent };